import React, { useEffect, useState } from 'react';
import './UpdateNotifier.css';

const UpdateNotifier = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(null);

  useEffect(() => {
    // Check for updates every 5 minutes
    const checkInterval = 5 * 60 * 1000; // 5 minutes

    const checkForUpdates = async () => {
      try {
        // Add timestamp to prevent caching
        const response = await fetch(
          `${process.env.REACT_APP_API_URL || 'http://localhost:8000/api'}/version.php?t=${Date.now()}`,
          {
            cache: 'no-store',
            headers: {
              'Cache-Control': 'no-cache',
            },
          }
        );

        const data = await response.json();

        if (data.success) {
          const serverVersion = data.version;

          // Get stored version from localStorage
          const storedVersion = localStorage.getItem('app_version');

          if (!storedVersion) {
            // First time - store current version
            localStorage.setItem('app_version', serverVersion);
            setCurrentVersion(serverVersion);
          } else if (storedVersion !== serverVersion) {
            // Version changed - show update notification
            setShowUpdate(true);
            setCurrentVersion(serverVersion);
          }
        }
      } catch (error) {
        console.error('Failed to check for updates:', error);
      }
    };

    // Check immediately on mount
    checkForUpdates();

    // Then check periodically
    const interval = setInterval(checkForUpdates, checkInterval);

    return () => clearInterval(interval);
  }, []);

  const handleUpdate = () => {
    // Store new version
    if (currentVersion) {
      localStorage.setItem('app_version', currentVersion);
    }

    // Force reload with cache clear
    window.location.reload(true);
  };

  const handleDismiss = () => {
    // Store new version to stop showing notification
    if (currentVersion) {
      localStorage.setItem('app_version', currentVersion);
    }
    setShowUpdate(false);
  };

  if (!showUpdate) {
    return null;
  }

  return (
    <div className="update-notifier-overlay">
      <div className="update-notifier-modal">
        <div className="update-icon">🔄</div>
        <h3>New Update Available!</h3>
        <p>
          A new version of the app is available. Please refresh to get the latest features and fixes.
        </p>
        <div className="update-actions">
          <button className="btn-update" onClick={handleUpdate}>
            ✓ Refresh Now
          </button>
          <button className="btn-dismiss" onClick={handleDismiss}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotifier;
